import { KMDSetting } from '@shared/models/kmdSetting';

/** The KMD Booking domain from `GET /kmdsettings`, without a trailing slash; empty when unset. */
export function kmdDomainOf(setting: KMDSetting | null | undefined): string {
  return (setting?.domain ?? '').replace(/\/+$/, '');
}

/**
 * The booking in KMD Booking. An association login has no access to KMD's admin pages, so it gets
 * the association's own booking page.
 */
export function kmdBookingUrl(domain: string, kmdId: string, associationLogin: boolean): string {
  return associationLogin
    ? `${domain}/Booking/Edit?id=${kmdId}`
    : `${domain}/Admin/Booking/Booking/${kmdId}`;
}

/**
 * "BookingID #123 · Bookingnr. 4030": abook's id and KMD's (`kmdBookingId` from the API), the
 * parts that are there.
 */
export function bookingIdsLabel(
  bookingId: number | null | undefined,
  kmdId: string | null | undefined,
): string {
  return [bookingId != null && `BookingID #${bookingId}`, kmdId && `Bookingnr. ${kmdId}`]
    .filter(Boolean)
    .join(' · ');
}
